module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', [_c('div', {
    staticClass: "grid-list"
  }, [_vm._m(0), _vm._v(" "), _c('loader', {
    attrs: {
      "show": _vm.isLoading
    }
  }), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "grid-content"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.vouchers.length > 0) ? _c('div', _vm._l((_vm.viewableVouchers), function(voucher, key, index) {
    return (_vm.showVoucher(voucher)) ? _c('div', {
      staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
    }, [_c('div', {
      staticClass: "grid-item"
    }, [_c('h4', [_vm._v(_vm._s(voucher.label))]), _vm._v(" "), _c('p', [_c('i', {
      staticClass: "fa fa-calendar",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" " + _vm._s(voucher.date))]), _vm._v(" "), _c('div', {
      staticClass: "row grid-item-footer"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('button', {
      staticClass: "md-btn pull-right",
      attrs: {
        "type": "submit"
      },
      on: {
        "click": function($event) {
          return _vm.downloadVoucher(voucher)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download",
      attrs: {
        "aria-hidden": "true"
      }
    })])]), _vm._v(" "), _vm._m(1, true)])])]) : _vm._e()
  }), 0) : _c('div', {
    staticClass: "col-xs-12 col-sm-21 col-md-6 col-lg-6"
  }, [_vm._m(2)])])]) : _vm._e()], 1)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid-head"
  }, [_c('h3', [_vm._v("\r\n         Vouchers "), _c('i', {
    staticClass: "fa fa-list-alt pull-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('small', {
    staticClass: "text-info"
  }, [_vm._v("Controleer of pop-ups zijn toegestaan.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid-item"
  }, [_c('p', [_vm._v("Geen vouchers te downloaden")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21358d2e"}!./src/templates/reservations/voucher-list.html
// module id = 532
// module chunks = 1